import { lazy } from 'react';

export const HelpPageAsync = lazy(() => import('./HelpPage'));
